import React from 'react';
import PropTypes from 'prop-types';

import AbstractWithFallback from './AbstractWithFallback';
import Avatar from '@material-ui/core/Avatar';

import classes from './AvatarWithFallback.scss';

export default class AvatarWithFallback extends AbstractWithFallback {
  static propTypes = {
    src        : PropTypes.string,
    fallbackSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    alt        : PropTypes.string,
    useImg     : PropTypes.bool,
  };

  render() {
    const { src, fallbackSrc, alt, useImg, classes: propClasses, ...rest } = this.props;

    if (useImg) {
      return (
        <div
          {...rest}
          className={propClasses.root}
          style={{backgroundImage: `url('${this.state.src}')`}}
        >
          <img className={classes['img--hidden']} src={this.state.src} alt={alt} onError={this.onError} />
        </div>
      )
    }

    return <Avatar src={this.state.src} alt={alt} classes={propClasses} {...rest} onError={this.onError} />;
  }
}
